import { auth,firebase,FacebookProvide } from './firebase';


// Sign Up
export const doCreateUserWithEmailAndPassword = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password);

// Sign In
export const doSignInWithEmailAndPassword = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

// Sign Facebook In
export const doSignInWithFacebook = () => {
  // var provide = new auth.FacebookAuthProvider();

  var provider = FacebookProvide();

  provider.addScope('email');
  auth.languageCode = 'pt_BR';
  provider.setCustomParameters({
    'display': 'popup'
  });

  auth.signInWithRedirect(provider);

  auth.getRedirectResult().then(function(result) {
  if (result.credential) {
    // This gives you a Facebook Access Token. You can use it to access the Facebook API.
    var token = result.credential.accessToken;
    // ...
  }
  // The signed-in user info.
  var user = result.user;
  }).catch(function(error) {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
    // The email of the user's account used.
    var email = error.email;
    // The firebase.auth.AuthCredential type that was used.
    var credential = error.credential;
    // ...
  });
}

// Sign out
export const doSignOut = () => {
  auth.signOut();
  console.log("signout");
}

// Password Reset
export const doPasswordReset = (email) =>
  auth.sendPasswordResetEmail(email);

// Password Change
export const doPasswordUpdate = (password) =>
  auth.currentUser.updatePassword(password);



// WEBPACK FOOTER //
// ./src/firebase/auth.js